import React from "react";

const emphasisRowStyle: React.CSSProperties = {
  background: "var(--gray-200)",
  fontSize: 14,
  fontWeight: 600,
};

export const GridHeaderCell = (props: React.ThHTMLAttributes<HTMLTableCellElement>) => (
  <th {...props} style={{ ...props.style, ...emphasisRowStyle, padding: "12px 8px" }} />
);
